module.exports = __webpack_public_path__ + "img/neg energy.c7054154.png";